if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        //this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.cart = document.querySelector('cart-notification');
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            
            fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then(data => {
              let hasDiscount75 = false;
              let hasDiscount100 = false;
              let productID75, productID100;
              if(document.querySelector('.free-product-100')) {
                productID100 = parseInt(document.querySelector('.free-product-100').dataset.id);
                for(var i = 0; i < data.items.length; i++){
                  if(data.items[i].id == productID100){
                    hasDiscount100 = true; 
                    break;
                  }
                }
              }
              if(document.querySelector('.free-product-75')) {
                productID75 = parseInt(document.querySelector('.free-product-75').dataset.id);
                for(var i = 0; i < data.items.length; i++){
                  if(data.items[i].id == productID75){
                    hasDiscount75 = true; 
                    break;
                  }
                }
              }
              
              if(data.total_price >= 10000 && hasDiscount100 == false && document.querySelector('.free-product-100')) {
                $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: {
                    quantity: 1,
                    id: productID100
                  },
                  dataType: 'json', 
                  success: function(response) {
                    console.log('Product added to cart:', response);
                    fetch(`${routes.cart_url}?section_id=cart-drawer`)
                    .then((response) => response.text())
                    .then((responseText) => {
                      const html = new DOMParser().parseFromString(responseText, 'text/html');
                      const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
                      for (const selector of selectors) {
                        const targetElement = document.querySelector(selector);
                        const sourceElement = html.querySelector(selector);
                        if (targetElement && sourceElement) {
                          targetElement.replaceWith(sourceElement);
                        }
                      }
                    })
                    .catch((e) => {
                      console.error(e);
                    });
                  }
               });
              } else if(data.total_price >= 7500 && data.total_price < 10000 && hasDiscount75 == false && document.querySelector('.free-product-75')) {
                $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: {
                    quantity: 1,
                    id: productID75
                  },
                  dataType: 'json', 
                  success: function(response) {
                    console.log('Product added to cart:', response);
                    fetch(`${routes.cart_url}?section_id=cart-drawer`)
                    .then((response) => response.text())
                    .then((responseText) => {
                      const html = new DOMParser().parseFromString(responseText, 'text/html');
                      const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
                      for (const selector of selectors) {
                        const targetElement = document.querySelector(selector);
                        const sourceElement = html.querySelector(selector);
                        if (targetElement && sourceElement) {
                          targetElement.replaceWith(sourceElement);
                        }
                      }
                    })
                    .catch((e) => {
                      console.error(e);
                    });
                  }
               });
              } else if (data.total_price < 10000 && document.querySelector('.free-product-100')) {
                let updates = {
                  [productID100]: 0,
                };
                fetch(window.Shopify.routes.root + 'cart/update.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({ updates })
                })
                .then(response => {
                  return response.json();
                })
                .then(data => {
                  fetch(`${routes.cart_url}?section_id=cart-drawer`)
                  .then((response) => response.text())
                  .then((responseText) => {
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
                    for (const selector of selectors) {
                      const targetElement = document.querySelector(selector);
                      const sourceElement = html.querySelector(selector);
                      if (targetElement && sourceElement) {
                        targetElement.replaceWith(sourceElement);
                      }
                    }
                  })
                  .catch((e) => {
                    console.error(e);
                    });
                })
                .catch((error) => {
                  console.error('Error:', error);
                });
              } else if (data.total_price < 7500 && document.querySelector('.free-product-75')) {
                let updates = {
                  [productID75]: 0,
                };
                console.log('updates', updates)
                fetch(window.Shopify.routes.root + 'cart/update.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({ updates })
                })
                .then(response => {
                  return response.json();
                })
                .then(data => {
                  fetch(`${routes.cart_url}?section_id=cart-drawer`)
                  .then((response) => response.text())
                  .then((responseText) => {
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
                    for (const selector of selectors) {
                      const targetElement = document.querySelector(selector);
                      const sourceElement = html.querySelector(selector);
                      if (targetElement && sourceElement) {
                        targetElement.replaceWith(sourceElement);
                      }
                    }
                  })
                  .catch((e) => {
                    console.error(e);
                    });
                })
                .catch((error) => {
                  console.error('Error:', error);
                });
              }
            });

            /* Free shipping */
            /*
            fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then(data => {
              const shippingCountdownSelector = document.querySelectorAll(".shipping-countdown p span");
              const cleanCartTotal = (data.items_subtotal_price) / 100;
              const shippingThreshold = parseInt(document.querySelector(".shipping-countdown .shipping-threshold").innerText);
              const emptyCart = document.querySelectorAll(".shipping-countdown .empty-cart");
              const progressCart = document.querySelectorAll(".shipping-countdown .progress-cart");
              const fullCart = document.querySelectorAll(".shipping-countdown .full-cart");
        
              if(cleanCartTotal > 0 && cleanCartTotal < shippingThreshold) {
                for (var i = 0; i < emptyCart.length; i++) {
                  emptyCart[i].style.display = "none";
                }
                for (var i = 0; i < fullCart.length; i++) {
                  fullCart[i].style.display = "none";
                }
                for (var i = 0; i < progressCart.length; i++) {
                  progressCart[i].style.display = "block";
                }
                for (var i = 0; i < shippingCountdownSelector.length; i++) {
                  shippingCountdownSelector[i].innerHTML = '$' + parseFloat(shippingThreshold - cleanCartTotal).toFixed(2);
                }
              } else if(cleanCartTotal >= shippingThreshold) {
                for (var i = 0; i < emptyCart.length; i++) {
                  emptyCart[i].style.display = "none";
                }
                for (var i = 0; i < progressCart.length; i++) {
                  progressCart[i].style.display = "none";
                }
                for (var i = 0; i < fullCart.length; i++) {
                  fullCart[i].style.display = "block";
                }
              } else if(cleanCartTotal == 0) {
                for (var i = 0; i < fullCart.length; i++) {
                  fullCart[i].style.display = "none";
                }
                for (var i = 0; i < progressCart.length; i++) {
                  progressCart[i].style.display = "none";
                }
                for (var i = 0; i < emptyCart.length; i++) {
                  emptyCart[i].style.display = "block";
                }
              }
              return data
            });
            */

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    //this.cartDrawer.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              //this.cartDrawer.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (this.cartDrawer && this.cartDrawer.classList.contains('is-empty')) this.cartDrawer.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            if(document.querySelector('.drawer__inner-empty')) {
              document.querySelector('.drawer__inner-empty').remove();
            }
            document.getElementById('CartDrawer-Checkout').disabled = false;
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
